import { useEffect }    from 'react';
import { userInfoType } from 'types';

const useModalHooks = ( userInfo: userInfoType ) => {

    useEffect(() => {
        if ( userInfo.subscriptionExpired ) {
          import("functions/modal/open_modal").then(openModal => {
            openModal.handleOpenModal('subscriptionExpired')
          }); 
        }
        if ( userInfo.userLogedIn === 'false' ) {
          import("functions/modal/open_modal").then(openModal => {
            openModal.handleOpenModal('userNotLoggedIn')
          }); 
        }
      },[userInfo])
    
}

export default useModalHooks